/* Parches y personalizacion de la ficha.

   Shopify no sabe cobrar un extra sobre una propiedad de linea. Por eso el
   recargo entra al carrito como un producto aparte, con dos variantes:
   «Jugador de la plantilla» y «Tu nombre». Lo que se elige aqui decide
   cual de las dos se agrega.

   Los jugadores y los parches de cada equipo viven en tlr-plantillas.js,
   que se carga antes que este archivo. Para cambiar un plantel se edita
   ese archivo y nada mas. */
(function () {
  "use strict";

  var caja = document.querySelector("[data-opciones]");

  /* La barra pegada vive aunque no haya personalizacion. */
  (function () {
    var barra = document.querySelector("[data-sticky]");
    var boton = document.querySelector("[data-agregar]");
    if (!barra || !boton || !("IntersectionObserver" in window)) { return; }
    var io = new IntersectionObserver(function (f) {
      var r = f[0];
      barra.classList.toggle("on", !r.isIntersecting && r.boundingClientRect.top < 0);
    }, { threshold: 0 });
    io.observe(boton);
    barra.addEventListener("click", function (ev) {
      if (ev.target.closest("[data-sticky-add]")) {
        boton.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    });
  })();

  if (!caja) { return; }

  var handle = caja.getAttribute("data-opciones");
  var parchesBase = caja.getAttribute("data-parches-url");
  var zonaParches = caja.querySelector("[data-zona-parches]");
  var zonaJug = caja.querySelector("[data-zona-jugadores]");
  var form = document.getElementById("form-producto");

  var esc = function (s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  };

  var sel = { parche: "Sin parches", modo: "sin", jugador: "", dorsal: "" };

  /* ── Parches ──────────────────────────────────────────────────────
     Con foto. Ver el parche antes de elegirlo evita la pregunta «¿cual
     me va a llegar?», que es la que llegaba por WhatsApp. */
  function pintarParches(lista) {
    if (!lista || lista.length < 2 || !zonaParches) { return; }
    var opts = zonaParches.querySelector("[data-opts]");
    opts.innerHTML = lista.map(function (o, k) {
      var corto = o.v.replace("Parches de ", "");
      corto = corto.charAt(0).toUpperCase() + corto.slice(1);
      var img = o.i && parchesBase
        ? '<img class="par-img" src="' + parchesBase + o.i + '.webp" alt="" loading="lazy" onerror="this.remove()">'
        : '<span class="par-img par-nada" aria-hidden="true"></span>';
      return '<button type="button" class="par" data-par="' + esc(o.v) + '" aria-pressed="' + (k === 0) + '">' +
             img + '<b>' + esc(corto) + '</b></button>';
    }).join("");
    zonaParches.hidden = false;

    opts.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-par]");
      if (!b) { return; }
      Array.prototype.forEach.call(opts.querySelectorAll("[data-par]"), function (x) {
        x.setAttribute("aria-pressed", "false");
      });
      b.setAttribute("aria-pressed", "true");
      sel.parche = b.getAttribute("data-par");
      zonaParches.querySelector("[data-valor]").textContent = sel.parche;
    });
  }

  /* ── Los cinco de la plantilla ──────────────────────────────────── */
  function pintarJugadores(lista) {
    if (!zonaJug) { return; }
    var rejilla = zonaJug.querySelector("[data-jugadores]");
    var pestJ = zonaJug.querySelector('[data-modo="jugador"]');
    if (!lista || !lista.length) {
      if (pestJ) { pestJ.remove(); }
      return;
    }
    rejilla.innerHTML = lista.map(function (j, k) {
      var p = j.split("|");
      var nombre = p[0];
      var dorsal = p[1] || "";
      return '<button type="button" class="jug" data-jug="' + esc(nombre) + '" data-dorsal="' + esc(dorsal) + '" aria-pressed="' + (k === 0) + '">' +
             '<span class="jug-n">' + esc(nombre) + '</span>' +
             (dorsal ? '<span class="jug-d">' + esc(dorsal) + '</span>' : "") +
             '</button>';
    }).join("");

    var primero = lista[0].split("|");
    sel.jugador = primero[0];
    sel.dorsal = primero[1] || "";

    rejilla.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-jug]");
      if (!b) { return; }
      Array.prototype.forEach.call(rejilla.querySelectorAll("[data-jug]"), function (x) {
        x.setAttribute("aria-pressed", "false");
      });
      b.setAttribute("aria-pressed", "true");
      sel.jugador = b.getAttribute("data-jug");
      sel.dorsal = b.getAttribute("data-dorsal");
    });
  }

  /* ── Las tres pestañas ─────────────────────────────────────────── */
  var pestanas = caja.querySelector("[data-modos]");
  if (pestanas) {
    pestanas.addEventListener("click", function (ev) {
      var b = ev.target.closest("[data-modo]");
      if (!b) { return; }
      sel.modo = b.getAttribute("data-modo");
      Array.prototype.forEach.call(pestanas.querySelectorAll("[data-modo]"), function (x) {
        x.setAttribute("aria-pressed", String(x === b));
      });
      Array.prototype.forEach.call(caja.querySelectorAll("[data-panel]"), function (pn) {
        pn.hidden = pn.getAttribute("data-panel") !== sel.modo;
      });
    });
  }

  /* ── Al agregar al carrito ────────────────────────────────────── */
  if (form) {
    form.addEventListener("submit", function (ev) {
      var props = {};
      if (sel.parche && sel.parche !== "Sin parches") { props["Parches"] = sel.parche; }

      var extra = null;
      if (sel.modo === "jugador" && sel.jugador) {
        props["Nombre"] = sel.jugador;
        if (sel.dorsal) { props["Numero"] = sel.dorsal; }
        extra = caja.getAttribute("data-var-jugador");
      } else if (sel.modo === "propio") {
        var campo = caja.querySelector("[name='pers-nombre']");
        var campoN = caja.querySelector("[name='pers-numero']");
        var n = campo ? campo.value.trim() : "";
        if (!n) {
          ev.preventDefault();
          campo.focus();
          campo.classList.add("es-error");
          setTimeout(function () { campo.classList.remove("es-error"); }, 1600);
          return;
        }
        props["Nombre"] = n.toUpperCase();
        if (campoN && campoN.value.trim()) { props["Numero"] = campoN.value.trim(); }
        extra = caja.getAttribute("data-var-propio");
      }

      if (!Object.keys(props).length && !extra) { return; }

      ev.preventDefault();
      var boton = form.querySelector("[data-agregar]");
      var rotulo = boton ? boton.textContent : "";
      if (boton) { boton.disabled = true; boton.textContent = "Agregando..."; }

      var items = [{ id: Number(form.querySelector("[data-variante]").value), quantity: 1, properties: props }];
      if (extra) { items.push({ id: Number(extra), quantity: 1 }); }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { throw new Error("no"); }
        location.href = "/cart";
      }).catch(function () {
        if (boton) { boton.disabled = false; boton.textContent = rotulo; }
        form.submit();
      });
    });
  }

  /* ── Los datos ───────────────────────────────────────────────── */
  var datos = window.TLR_DATOS;
  var reg = datos && datos.h && datos.h[handle] !== undefined ? datos.g[datos.h[handle]] : null;
  if (reg) {
    pintarParches(reg.pa);
    pintarJugadores(reg.pl);
  } else {
    var pestJ = caja.querySelector('[data-modo="jugador"]');
    if (pestJ) { pestJ.remove(); }
  }
})();
